"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[74584],{

/***/ 74584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AppDevelopmentCommon": function() { return /* binding */ AppDevelopmentCommon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96076);








var TableSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(4578)]).then(__webpack_require__.bind(__webpack_require__, 27));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27)
            ];
        }
    }
});
var TableSectionNew = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(29853)]).then(__webpack_require__.bind(__webpack_require__, 7777));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7777)
            ];
        }
    }
});
var TableCalculator = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(84513)]).then(__webpack_require__.bind(__webpack_require__, 28058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28058)
            ];
        }
    }
});
var CardsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(2013), __webpack_require__.e(54223)]).then(__webpack_require__.bind(__webpack_require__, 90058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90058)
            ];
        }
    }
});
var ProcessSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(70600), __webpack_require__.e(15805), __webpack_require__.e(95436), __webpack_require__.e(6169)]).then(__webpack_require__.bind(__webpack_require__, 35845));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35845)
            ];
        }
    }
});
var DownloadSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(28352)]).then(__webpack_require__.bind(__webpack_require__, 6189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6189)
            ];
        }
    }
});
var TabsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(13971), __webpack_require__.e(6050)]).then(__webpack_require__.bind(__webpack_require__, 76974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76974)
            ];
        }
    }
});
var CheckListSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(57126)]).then(__webpack_require__.bind(__webpack_require__, 74861));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74861)
            ];
        }
    }
});
var NumberedListSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(59904)]).then(__webpack_require__.bind(__webpack_require__, 74233));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74233)
            ];
        }
    }
});
var SliderSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(82765), __webpack_require__.e(13054)]).then(__webpack_require__.bind(__webpack_require__, 55410));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55410)
            ];
        }
    }
});
var GallerySection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(82484)]).then(__webpack_require__.bind(__webpack_require__, 67974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67974)
            ];
        }
    }
});
var ImageSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(98971), __webpack_require__.e(78793)]).then(__webpack_require__.bind(__webpack_require__, 77443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77443)
            ];
        }
    }
});
var FaqSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(49119), __webpack_require__.e(88659)]).then(__webpack_require__.bind(__webpack_require__, 65016));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65016)
            ];
        }
    }
});
var ReviewsSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(15805), __webpack_require__.e(5205), __webpack_require__.e(17287)]).then(__webpack_require__.bind(__webpack_require__, 77359));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77359)
            ];
        }
    }
});
var ImagesListSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(25632)]).then(__webpack_require__.bind(__webpack_require__, 36587));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36587)
            ];
        }
    }
});
var LinkList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(63712)]).then(__webpack_require__.bind(__webpack_require__, 78841));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78841)
            ];
        }
    }
});
var AppFeatures = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(22666)]).then(__webpack_require__.bind(__webpack_require__, 98074));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98074)
            ];
        }
    }
});
var SvgListSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(40243), __webpack_require__.e(83522)]).then(__webpack_require__.bind(__webpack_require__, 12076));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12076)
            ];
        }
    },
    ssr: false
});
var BookmarkCardSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 75650).then(__webpack_require__.bind(__webpack_require__, 75650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75650)
            ];
        }
    }
});
var Parallax = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(88840), __webpack_require__.e(51926)]).then(__webpack_require__.bind(__webpack_require__, 97736));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97736)
            ];
        }
    }
});
var PageIntroSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(46680), __webpack_require__.e(89331), __webpack_require__.e(13189)]).then(__webpack_require__.bind(__webpack_require__, 13189));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13189)
            ];
        }
    }
});
var PlainTextSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(46680), __webpack_require__.e(83509), __webpack_require__.e(59544)]).then(__webpack_require__.bind(__webpack_require__, 57149));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57149)
            ];
        }
    }
});
var FeedbackSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(64055)]).then(__webpack_require__.bind(__webpack_require__, 43394));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43394)
            ];
        }
    }
});
var SoftwarePriceSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(98885), __webpack_require__.e(43919), __webpack_require__.e(85131), __webpack_require__.e(11299)]).then(__webpack_require__.bind(__webpack_require__, 11299));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11299)
            ];
        }
    }
});
var BookCallIntro = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(63126), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(52292)]).then(__webpack_require__.bind(__webpack_require__, 679));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(679)
            ];
        }
    }
});
var VideoSection = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(38267)]).then(__webpack_require__.bind(__webpack_require__, 60464));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60464)
            ];
        }
    }
});
var Team = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(98885), __webpack_require__.e(61793), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(53668)]).then(__webpack_require__.bind(__webpack_require__, 79143));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79143)
            ];
        }
    }
});
var Wireframes = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(8538), __webpack_require__.e(54042)]).then(__webpack_require__.bind(__webpack_require__, 64757));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64757)
            ];
        }
    }
});
var VideoGallery = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(15805), __webpack_require__.e(68310)]).then(__webpack_require__.bind(__webpack_require__, 69236));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69236)
            ];
        }
    }
});
var CardsSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(30719), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(50350), __webpack_require__.e(19341)]).then(__webpack_require__.bind(__webpack_require__, 35637));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35637)
            ];
        }
    }
});
var SvgList = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(53662), __webpack_require__.e(25675), __webpack_require__.e(74129), __webpack_require__.e(6778), __webpack_require__.e(15805), __webpack_require__.e(90934), __webpack_require__.e(97)]).then(__webpack_require__.bind(__webpack_require__, 15804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15804)
            ];
        }
    }
});
var AppDevelopmentCommon = function(_param) {
    var introSection = _param.introSection, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "introSection"
    ]);
    var type = props.type, section = props.section, handleOnCTAClick = props.handleOnCTAClick;
    if (!section.fields) {
        return null;
    }
    var ref = (0,utils_helper__WEBPACK_IMPORTED_MODULE_3__/* .getDocumentFields */ .OA)(section, [
        "type",
        "slug"
    ]), sectionType = ref.type, slug = ref.slug;
    switch(sectionType || slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentPageIntro */ .$w.appDevelopmentPageIntro:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageIntroSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                introSection: introSection
            }, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentImageSection */ .$w.appDevelopmentImageSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentCards */ .$w.appDevelopmentCards:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentSliderCards */ .$w.appDevelopmentSliderCards:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                withSlider: true
            }));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentRelatedServices */ .$w.appDevelopmentRelatedServices:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
                withSlider: true
            }));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentCheckList */ .$w.appDevelopmentCheckList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CheckListSection, {
                sectionData: section,
                type: type,
                handleOnCTAClick: handleOnCTAClick
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentNumberedList */ .$w.appDevelopmentNumberedList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NumberedListSection, {
                sectionData: section,
                type: type,
                handleOnCTAClick: handleOnCTAClick
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentSvgList */ .$w.appDevelopmentSvgList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgListSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentSlider */ .$w.appDevelopmentSlider:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderSection, {
                sectionData: section,
                type: type,
                handleOnCTAClick: handleOnCTAClick
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentGallery */ .$w.appDevelopmentGallery:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GallerySection, {
                sectionData: section,
                type: type,
                handleOnCTAClick: handleOnCTAClick
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentFAQ */ .$w.appDevelopmentFAQ:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentReviews */ .$w.appDevelopmentReviews:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewsSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentImagesList */ .$w.appDevelopmentImagesList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImagesListSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentProcess */ .$w.appDevelopmentProcess:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProcessSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentCheckSocial */ .$w.appDevelopmentCheckSocial:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LinkList, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.svgDisplayWithSelector */ .$w.svgDisplayWithSelector:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgListSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                withSelector: true
            }, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.cardsWithOverlay */ .$w.cardsWithOverlay:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSection, {
                section: section,
                type: type,
                withOverlay: true
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentAppFeatures */ .$w.appDevelopmentAppFeatures:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppFeatures, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentAppFeaturesPromo */ .$w.appDevelopmentAppFeaturesPromo:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AppFeatures, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                isPromoImage: true
            }, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentPlainTextSection */ .$w.appDevelopmentPlainTextSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PlainTextSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentBookmarkCard */ .$w.appDevelopmentBookmarkCard:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookmarkCardSection, {
                sectionData: section,
                pageType: type,
                handleOnCTAClick: handleOnCTAClick
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.parallax */ .$w.parallax:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Parallax, {
                type: type,
                data: section.fields
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentTabsSection */ .$w.appDevelopmentTabsSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TabsSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentDownloadSection */ .$w.appDevelopmentDownloadSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.appDevelopmentTableSection */ .$w.appDevelopmentTableSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.tableSection */ .$w.tableSection:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableSectionNew, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.tableCalculator */ .$w.tableCalculator:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TableCalculator, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.feedback */ .$w.feedback:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FeedbackSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.softwarePriceForm */ .$w.softwarePriceForm:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SoftwarePriceSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.team */ .$w.team:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Team, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.wireframes */ .$w.wireframes:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wireframes, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case "book-call-intro":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BookCallIntro, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                introSection: introSection
            }, props));
        case "video":
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoSection, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.videosGallery */ .$w.videosGallery:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(VideoGallery, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.cardsSlider */ .$w.cardsSlider:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CardsSlider, {
                section: section,
                type: type
            });
        case utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .APP_DEVELOPMENT_TYPES.svgList */ .$w.svgList:
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SvgList, {
                section: section,
                type: type
            });
        default:
            return null;
    }
};
AppDevelopmentCommon.defaultProps = {
    handleOnCTAClick: function() {},
    introSection: null
};
AppDevelopmentCommon.propTypes = {
    section: prop_types__WEBPACK_IMPORTED_MODULE_7___default().instanceOf(Object).isRequired,
    type: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    handleOnCTAClick: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    introSection: prop_types__WEBPACK_IMPORTED_MODULE_7___default().instanceOf(Object)
};


/***/ })

}]);